/**
 * An internal function to convert strings to kebab case. This function replaces all consecutive punctuation with an
 * empty space, trims any extra white space, replaces any instances of one or more empty spaces to with a single
 * hyphen, and then converts the string to lower case. This function is intended to be used instead of lodash's kebab
 * case function when latin characters with stressors are not to be replaced with their unstressed counterparts when
 * being converted to kebab case.
 */
export const kebabCase = (str: string) => {
  if (typeof str !== 'string') {
    return '';
  }

  return str.replace(/[.,\[\]\<\>\'\"|\/#!@$%\^&\*?;:{}=\-\_`\~(\)+\\]+/g,' ')
  .trim().replace(/[\s]+/g, '-').toLowerCase();
};

/**
 * Converts a string to snake_case, replacing spaces with underscores and converting the 
 * resulting string to lower case. If the provided value is not a string, an empty
 * string is returned.
 */
export const snakeCase = (str: string) => {
  if (typeof str !== 'string') {
    return '';
  }

  return str.split(' ').join('_').toLowerCase();
};
